// Dependencies
import styled from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    display: block;
    padding-block: 0.5rem;

    &:hover {
        background-color: ${theme.colors.base[100]};
    }

    &.level-1 {
        padding-left: 16px;
    }

    &.level-2 {
        padding-left: 32px;
    }

    &.level-3 {
        padding-left: 48px;
    }
`;
